import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';

import { normalizeVideo } from 'shared/redux/helpers/normalized';


const ACTIONS = createAsyncActions('SERVER.CHANNEL.VIDEO.GET');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


function getVideo(method, channelId, videoId) {

  return function (dispatch) {
    const params = { channelId, videoId };
    dispatch(START(params));

    const promise = vodAdapter.listItems[method](channelId, videoId);

    return promise
      .then(
        function (response) {
          response = {
            ...response,
            data: normalizeVideo(response.data),
          };

          dispatch(SUCCESS(params, response));
          return response;
        },

        function (response) {
          dispatch(FAIL(params, response, { analytics: { type: 'error', name: 'shared.channel.video.get' } }));
        }
      );
  };
}


export default _.partial(getVideo, 'get');

export const getPublic = _.partial(getVideo, 'getPublic');



// WEBPACK FOOTER //
// ./src/shared/redux/server/actions/channel/video/get.js